<template>
  <div>
    

    <CJumbotron class="pbx-ae">

      <h1 class="display-3">
          ویرایش پروفایل
      </h1>
      <p class="lead">
           در این صفحه میتوانید پروفایل مرکز تماس ابری خود را ویرایش و یا پسورد خود را تغییر دهید. 
      </p>
      <img class="c-avatar-img" :src="'https://api.hamkaran.cloud/avatar/'+data.email" />

      <CButton
          :title="$t('users.data.edit.help')"
          color="success"
          size="sm"
          @click="whatsapp_modal()"
        >
          <i class="fa-brands fa-whatsapp"></i>
          اتصال به واتساپ
        </CButton>
    </CJumbotron>
    <CRow>
      <CCol md="6" sm="12" class="hamkaran-report">
      <CElementCover v-if="loading" :opacity="1" class="h-loadin">
        <CSpinner size="5xl" />
      </CElementCover>
        <CCard>
          <CCardHeader class="hamkaran_header">
            اطلاعات پایه شما
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="3">
                <CSelect 
                  disabled ="disabled"
                  label="نوع ثبت نام"
                  placeholder="انتخاب نوع"
                  :options="[ { value: 1, label: 'حقیقی' }, { value: 2, label: 'حقوقی' } ]"
                  :value.sync="data.type"
                />
              </CCol>
              <CCol md="9">
                <CInput
                  disabled ="disabled"
                  label="لایسنس ارتباط داخلی"
                  placeholder="لایسنس ارتباط داخلی"
                  value="--->>  Hamkaran Cloud Key is Private <<---"
                />
              </CCol>
              <CCol md="8">
                <CInput
                  :disabled="isDisabled"
                  label="نام مرکز تماس (نام کسب‌وکار)"
                  placeholder="نام استارتاپ و یا کسب و کار استفاده کننده وارد شود"
                  v-model="data.company"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  disabled ="disabled"
                  label="کد مرکز تماس"
                  placeholder="کد سه رقمی مرکز تماس"
                  v-model="data.prefix"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="نام و نام خانوادگی رابط اصلی"
                  placeholder="نام و نام کاربری خانوادگی اصلی وارد شود"
                  v-model="data.agent"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  disabled ="disabled"
                  label="ایمیل رابط اصلی"
                  placeholder="ایمیل رابط اصلی وارد شود"
                  v-model="data.email"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  disabled ="disabled"
                  label="موبایل رابط اصلی"
                  placeholder="موبایل رابط اصلی وارد شود"
                  v-model="data.agent_mobile"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>


      </CCol>
      <CCol md="6" sm="12" class="hamkaran-report">
        
        <CElementCover v-if="loading" :opacity="1" class="h-loadin">
          <CSpinner size="5xl" />
        </CElementCover>

        <CCard>
          <CCardHeader class="hamkaran_header">
            اطلاعات مرکز تماس ابری
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6">
                
                <CSelect 
                  disabled ="disabled"
                  label="نوع اشتراک"
                  placeholder="انتخاب نوع"
                  :options="[ { value: 1, label: 'طرح پایه' }, { value: 2, label: 'طرح دو' }, { value: 3, label: 'طرح سه' }, { value: 4, label: 'طرح چهارم' }, { value: 5, label: 'طرح پنج' }, { value: 6, label: 'طرح‌‌های ویژه' } ]"
                  :value.sync="data.subscription_type"
                />
   
              </CCol>
              <CCol md="6">
                <CInput
                  disabled ="disabled"
                  label="تعداد داخلی‌های اشتراک"
                  placeholder=""
                  v-model="data.extensions_count"
                />
              </CCol>
              <CCol md="6">
                <div role="group" class="form-group">
                  <label for="uid-g4841pcw9cg" class=""> تاریخ تحویل</label>
                  <date-picker
                    disabled ="disabled"
                    placeholder="تاریخ تحویل"
                    v-model="data.operation_start_date"
                    :clearable="true"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                  />
                </div>
                <CInput
                  label="گذرواژه"
                  placeholder=""
                  v-model="data.password"
                />
              </CCol>
              <CCol md="6">
                <CTextarea
                  disabled ="disabled"
                  label="توضیحات اشتراک"
                  placeholder=""
                  v-model="data.subscription_dec"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

     <CCol md="12" sm="12" class="hamkaran-report">
        
        <CElementCover v-if="loading" :opacity="1" class="h-loadin">
          <CSpinner size="5xl" />
        </CElementCover>

        <div style="position: relative">
          <div class="table-responsive table-responsive-trunks">
            <table class="table table-striped table-hover trunks">
              <thead>
                <tr>
                  <th>
                    شماره ترانک
                  </th>
                  <th style="width: 141px;">
                    کانال
                  </th>
                  <th style="width: 141px;">
                    گذرواژه
                  </th>
                  <th style="width: 141px;">
                     شناسه تامین کننده
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(trunk, index) in data.trunks" :key="index" >
                  <td>
                    <CInput
                      disabled ="disabled"
                      placeholder=""
                      v-model="trunk.number"
                    />
                  </td>
                  <td>
                    <CInput
                      placeholder=""
                      disabled ="disabled"
                      v-model="trunk.channel"
                    />
                  </td>
                  <td style="text-align: center;">
                    *********
                  </td>
                  <td>
                    <CInput
                      placeholder=""
                      disabled ="disabled"
                      v-model="trunk.id"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <CButton
          @click="storedata();"
          color="primary"
        >
          ذخیره سازی
        </CButton>
      </CCol>

    </CRow>
    <CAlert
      color="danger"
      class="notifi"
      closeButton
      :show.sync="currentAlertCounter"
      >
      <b>
        {{error_msg.statusText}}({{error_msg.status}})
      </b>
      <div v-for="(msg, index) in error_msg.data[0]" :key="index">
        {{index}} :{{msg[0]}}
        <br>
      </div>
     <CProgress
        :max="10"
        :value="currentAlertCounter"
        height="3px"
        color="danger"
        animate/>
    </CAlert>
    <CAlert
      color="success"
      class="notifi"
      style="width: 250px;"
      closeButton
      :show.sync="successCounter"
      >
      <b>
        Saved successfully
      </b>
     <CProgress
        :max="10"
        :value="successCounter"
        height="3px"
        color="success"
        animate/>
    </CAlert>


    <CModal :title="whatsapp_connect.title" color="info" size="lg" :show.sync="whatsapp_connect.modal">
      <CRow>
        <CCol md="12">

          <div class="whatsapp_connect_warper">
            <span class="status">
              <CSpinner v-if="!whatsapp_connect.step1.isDone" size="sm"  />
              <i v-if="whatsapp_connect.step1.isDone"  style="color: green;font-size: 1rem;" class="fa-solid fa-circle-check"></i>
            </span>
            <span class="title">
              {{ $t("users.whatsapp.step1") }}
            </span>
          </div>
          

          <div class="whatsapp_connect_warper" v-if="whatsapp_connect.step1.isDone">
            <span class="status">
              <CSpinner v-if="!whatsapp_connect.step2.isDone" size="sm"  />
              <i v-if="whatsapp_connect.step2.isDone"  style="color: green;font-size: 1rem;" class="fa-solid fa-circle-check"></i>
            </span>
            <span class="title">
              {{ $t("users.whatsapp.step2") }}

             <span  v-if="whatsapp_connect.step2.response"> : {{whatsapp_connect.step2.response.status }}</span>
            </span>

            <div style="text-align: center;" v-if="!whatsapp_connect.step2.isDone && whatsapp_connect.step2.response && whatsapp_connect.step2.response.status == 'QRCODE'">
              <img :src="whatsapp_connect.step2.response.qrcode" alt="">
            </div>
          </div>

        </CCol>
      </CRow>

      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="whatsapp_connect.modal = false"
      >
        {{ $t("common.CANCEL") }}
      </button>

      <CButton
        v-if="whatsapp_connect.step2.isDone"
        slot="footer"
        type="button"
        class="btn btn-danger"
        @click="restartWhatsapp()"
      >
        <CSpinner v-if="restartWhatsappLoading" tag="span" size="md" />
        <CIcon v-if="!restartWhatsappLoading" class="top_menu" name="cil-ban" />
        <span v-if="!restartWhatsappLoading"> خروج و بازنشانی </span>
      </CButton>
    </CModal>
  </div>
</template>


<style >
td.oprate {
  width: 148px;
}
td.number {
  width: 118px;
}

td.name {
  width: 290px;
}
</style>


<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  name: "Profile",
  data() {
    return {
      restartWhatsappLoading:false,
      whatsapp_connect:{
        title:"",
        modal:false,
        step:0,
        step1:{
          isDone:0,
        },
        step2:{
          isDone:0,
          response:'',
          qrcode:''
        }
      },
      user: {
        id: "",
        prefix: "",
        password: "",
        email: "",
        agent_mobile: "",
        company: "شرکت طرح و توسعه پردازش همکاران",
        name: "",
        active: "",
        access_level: "",
      },
      
      timeouts: [],
      'data': {
        'id':'',
        'access_level':3,
        'active':1,
        'name':'', 
        'didar_id':'', 
        'email':'', 
        'password':'',
        'company':'',
        'number':'',
        'trunks':[
          {
          number : '',
          password : '',
          id : '',
          channel : '',
          }
        ],
        'prefix':'',
        'hamkaran_id':'',
        'hook_url':'',
        'cid_lockup':'',
        'contact_api':'',
        'agent_mobile':'',
        'agent':'',
        'provider':'',
        'provider_username':'',
        'provider_password':'',
        'provider_userid':'',
        'provider_dec':'',

      },
      'loading':true,
      'show_error':false,
      'error_msg':{
        'error_msg.data':null,
        'statusText':null,
        'status':null,
        'data':[]
      },
      'currentAlertCounter':0,
      'successCounter':0,
    };
    
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  mounted() {
    if(this.$route.params.prefix  == 'new'){
      this.loading =false;
      this.data.id="0";
    }else{

      this.getdata();
    }
    
  },
  methods: {
    whatsapp_modal: function () {
      this.clearTimeouts();
      this.whatsapp_connect={
        modal:false,
        step:0,
        step1:{
          isDone:0,
        },
        step2:{
          isDone:0,
          response:'',
          qrcode:''
        }
      };
      this.whatsapp_connect.modal = true;
      this.whatsapp_connect.title = 'کاربر: '+this.data.name+' موبایل: '+this.data.agent_mobile;
      this.user.id =this.data.id;
      this.user.name = this.data.name;
      this.user.prefix = this.data.prefix;
      this.user.active = this.data.active;
      this.user.email = this.data.email;
      this.user.agent_mobile = this.data.agent_mobile;
      this.user.mobile = this.data.mobile;
      this.user.access_level = this.data.access_level;

      this.whatsapp(1);

    },

    clearTimeouts() {
      this.timeouts.forEach(clearTimeout);
      this.timeouts = []; 
    },
    whatsapp: function (step) {
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      var user = JSON.parse(JSON.stringify(this.user));
      user.step=step;
      axios
        .post("https://api.hamkaran.cloud/api/v1/admin/whatsapp/step"+step, user)
        .then((response) => {
          console.log(response);
          if(response.data.step == 'step1'){
            this.whatsapp_connect[response.data.step].isDone = 1;
            this.whatsapp(response.data.next_step);
          }
          
          if(response.data.step  == 'step2'){
            this.whatsapp_connect[response.data.step].response=response.data.response;
            if(response.data.response.status == 'CONNECTED'){
              this.whatsapp_connect[response.data.step].isDone = 1;
            }else{
              const timeoutId = setTimeout(() => this.whatsapp(response.data.next_step), 5000);
              this.timeouts.push(timeoutId); 
            }
          }
          
        })
        .catch((error) => {
          const count = this.$store.state.alert.errorcount + 1;
          console.log(error.response);
          this.storeLoading = false;
          const alert = {
            error_msg: {
              statusText: "خطا در  پردازش",
              status: error.response.status,
              data: error.response.data,
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },
    restartWhatsapp: function () {
      this.restartWhatsappLoading=true;

      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      var user = JSON.parse(JSON.stringify(this.user));
      axios
        .post("https://api.hamkaran.cloud/api/v1/admin/whatsapp/stop", user)
        .then((response) => {
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: null,
              status: null,
              data: [],
            },
            successMessage: "از واتساپ با موفقیت خارج شد",
            successcount: count,
            errorcount: 0,
          };
          this.$store.commit("set", ["alert", alert]);
          this.restartWhatsappLoading=false;
          this.clearTimeouts();
          this.whatsapp_connect.modal = false;
        })
        .catch((error) => {
          const count = this.$store.state.alert.errorcount + 1;
          console.log(error.response);
          this.storeLoading = false;
          const alert = {
            error_msg: {
              statusText: "خطا در  پردازش",
              status: error.response.status,
              data: error.response.data,
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },
    beforeDestroy() {
      this.clearTimeouts();
    },

    addMore() {
      if(this.data.trunks == null)
        this.data.trunks=[];
      this.data.trunks.push({
          number : '',
          password : '',
          id : '',
        });
    },
    remove(index) {
     this.data.trunks.splice(index, 1);
    },
    getdata: function () {
      this.rows = this.data;
      this.loading = true;
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      axios
        .get(
          "https://api.hamkaran.cloud/api/v1/profile"
        )
        .then(
          (response) => (
            (this.loading = false),
            // (response.data.data.trunks=null),
            (this.data= response.data.data),
            (this.data.password = null)
          )
        ).catch( 
          (error) => {
             this.show_error= true;
             this.error_msg= error;
             this.currentAlertCounter = 10;
            }
        );
    },
    isDisabled() {
      const access_level = parseInt(this.$store.state.data.access_level, 10);
      return [1, 14, 15].includes(access_level);
    },
    storedata: function () {
      this.loading = false;
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      axios.post("https://api.hamkaran.cloud/api/v1/profile",this.data)
        .then(
          (response) => (
            (this.loading = false),
            (this.successCounter = 10)

          )
        ).catch( error => {
             this.show_error= true;
             this.error_msg= error.response;
             this.currentAlertCounter = 10 ;
        }
      );
    },
  },
};
</script>
